// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".application-list-section{min-height:600px}.application-list-section .breadcrumbs+.product-list{padding-top:25px}@media (max-width: 1049px){.application-list-section .breadcrumbs+.product-list{padding-top:15px}.application-list-section .product-info .product-info-title{font-size:16px}.application-list-section .product-list{padding-top:40px;padding-bottom:40px}}\n", ""]);
// Exports
module.exports = exports;
